import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { LightshowState } from '../lightshow-state';
import { LightShowSegment } from '../Segments/lightshow-segment';
import * as moment from 'moment';
import { LightShowService } from '../../../app/_services/light-show.service';

@Component({
  selector: 'app-fullscreen-preview',
  template: `
    <div #preview class='fullscreen-preview'>
        <div class='audio-controls'>
            <div class="controls">
                <button [disabled]="isPlaying" (click)="play.emit()">
                    <svg viewBox="0 0 36 36" style="height: 100%; width: 100%;">
                        <path d="M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28" />
                    </svg>
                </button>

                <button [disabled]="!isPlaying" (click)="pause.emit()">
                  <svg viewBox="0 0 36 36" style="height: 100%; width: 100%;">
                      <path d="M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26" />
                  </svg>
                </button>
                <div *ngIf='showElapsedTime' class="counter">{{ formatSecondsToMinutes(playPosition) }}</div>
                <input type="range" [value]="playPosition" min="0" [max]="trackDurationMs" step="16" class="music-slider" (input)="seekTime($event)"/>

            </div>
            <div class="close-fullscreen" (click)="closeFullscreen()">
                <span>+</span>
            </div>
        </div>

        <!-- <app-mp3-player
          [url]="mp3Url"
          [fullScreenPreviewMode]="true"
        >
        </app-mp3-player> -->

        <div class='preview-row' [ngStyle]="{ 'transform': 'translate('+ (windowWidth - 1920)/2 +'px)' }">
            <div class="preview-wrapper" *ngFor="let num of [0, 1, 2, 3, 4]">
                <app-preview
                    [state]="state"
                    [colorToDisplay]="colorToDisplay"
                    [colorSegmentOpacity]="colorSegmentOpacity"
                    [imageSegmentOpacity]="imageSegmentOpacity"
                    [selectedColorSegment]="selectedColorSegment"
                    [selectedImageSegment]="selectedImageSegment"
                    [fullscreenMode]="true">
                </app-preview>
            </div>
        </div>
    </div>
    `,
  styleUrls: ['./fullscreen-preview.component.css']

})

export class FullscreenPreviewComponent implements OnInit, OnDestroy {
  @Input()
  state: LightshowState;
  @Input()
  selectedColorSegment: LightShowSegment;
  @Input()
  selectedImageSegment: LightShowSegment;
  @Input()
  colorToDisplay: string;
  @Input()
  colorSegmentOpacity: number;
  @Input()
  imageSegmentOpacity: number;
  @Input()
  playPosition: number;
  @Input()
  isPlaying: number;
  // <-- mp3-player inputs -->
  @Input()
  mp3Url: any;
  @Input()
  duration: any;

  @Output()
  play = new EventEmitter();
  @Output()
  pause = new EventEmitter();
  @Output()
  changePlayPosition = new EventEmitter();

  @ViewChild('preview', {static: false})
  preview: ElementRef;

  showElapsedTime: any;

  @HostListener('document:keypress', ['$event'])
  handleKeyBoardEvent(e: KeyboardEvent) {
    if (e.key === ' ') {
      this.isPlaying ? this.pause.emit() : this.play.emit();
      e.preventDefault();
      return false;
    }
  }

  constructor(private lightShowService: LightShowService) {}

  ngOnInit() {
    document.addEventListener('fullscreenchange', this.changeHandler.bind(this), false);
    document.addEventListener('webkitfullscreenchange', this.changeHandler.bind(this), false);
    document.addEventListener('mozfullscreenchange', this.changeHandler.bind(this), false);

    this.showElapsedTime = document.exitFullscreen;
  }

  get trackDurationMs() {
    return moment.duration(this.duration).asMilliseconds();
  }

  changeHandler() {
    if (!document['fullscreenElement']) {
      this.lightShowService.showFullScreenPreview = false;
    }
  }

  formatSecondsToMinutes(time: number) {
    return moment(time).format('mm:ss');
  }

  get windowWidth() {
    let width = 0;

    if (document.exitFullscreen) {
      width = window.innerWidth;
    }

    return width;
  }

  seekTime(e: Event) {
    this.changePlayPosition.emit((e.target as HTMLInputElement).valueAsNumber);
  }

  closeFullscreen() {
    const isInFullScreen = (document['fullscreenElement'] && document['fullscreenElement'] !== null) ||
                           (document['webkitFullscreenElement'] && document['webkitFullscreenElement'] !== null) ||
                           (document['mozFullScreenElement'] && document['mozFullScreenElement'] !== null) ||
                           (document['msFullscreenElement'] && document['msFullscreenElement'] !== null);

    if (isInFullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document['webkitExitFullscreen']) {
        document['webkitExitFullscreen']();
      } else if (document['mozCancelFullScreen']) {
        document['mozCancelFullScreen']();
      } else if (document['msExitFullscreen']) {
        document['msExitFullscreen']();
      }
    }
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', this.changeHandler);
    document.removeEventListener('webkitfullscreenchange', this.changeHandler);
    document.removeEventListener('mozfullscreenchange', this.changeHandler);
  }
}


